export default (product) => {
    return product && product.soldOutOnline;
};
